export const ROUTINE_CATEGORIES = [
  {
    id: 'kitchen',
    name: 'Kitchen',
    iconName: 'ChefHat',
    tasks: [
      { id: 'kitchen-1', name: "Clean refrigerator coils", frequency_days: 180, description: "Vacuum dust from behind or under the fridge to maintain efficiency." },
      { id: 'kitchen-2', name: "Replace fridge water filter", frequency_days: 180, description: "Swap the filter to keep drinking water fresh." },
      { id: 'kitchen-3', name: "Descale dishwasher", frequency_days: 90, description: "Run a cycle with descaler or vinegar to remove hard water buildup." },
      { id: 'kitchen-4', name: "Clean oven interior", frequency_days: 90, description: "Wipe down grease and run the self-cleaning cycle if applicable." },
      { id: 'kitchen-5', name: "Clean extractor fan filters", frequency_days: 90, description: "Degrease the stove hood filters in hot soapy water." },
      { id: 'kitchen-6', name: "Clean garbage disposal", frequency_days: 30, description: "Grind ice cubes and citrus peels to sharpen blades and remove odors." },
      { id: 'kitchen-7', name: "Deep clean microwave", frequency_days: 30, description: "Boil a bowl of water with lemon to steam clean the interior." }
    ]
  },
  {
    id: 'laundry',
    name: 'Laundry',
    iconName: 'Shirt',
    tasks: [
      { id: 'laundry-1', name: "Clean washing machine filter", frequency_days: 30, description: "Remove lint and debris from the front bottom filter." },
      { id: 'laundry-2', name: "Run drum clean cycle", frequency_days: 90, description: "Run an empty hot wash to kill mold and smells." },
      { id: 'laundry-3', name: "Clean dryer lint trap", frequency_days: 7, description: "Empty the lint trap to prevent fire hazards." },
      { id: 'laundry-4', name: "Clean dryer exhaust duct", frequency_days: 180, description: "Clear the main exhaust vent of lint buildup." },
      { id: 'laundry-5', name: "Inspect washing machine hoses", frequency_days: 365, description: "Check rubber hoses for bulges, cracks, or leaks." }
    ]
  },
  {
    id: 'hvac',
    name: 'HVAC & Air',
    iconName: 'Wind',
    tasks: [
      { id: 'hvac-1', name: "Clean indoor AC filters", frequency_days: 30, description: "Wash or vacuum the dust filters in split units." },
      { id: 'hvac-2', name: "Clear outdoor unit debris", frequency_days: 90, description: "Remove leaves and dirt from the outdoor compressor." },
      { id: 'hvac-3', name: "Deep clean humidifier/dehumidifier", frequency_days: 30, description: "Sanitize the water tank to prevent mold." },
      { id: 'hvac-4', name: "Check smoke/CO detectors", frequency_days: 180, description: "Test alarms and replace batteries if necessary." },
      { id: 'hvac-5', name: "Dust ceiling fans", frequency_days: 90, description: "Wipe down blades to prevent dust circulation." }
    ]
  },
  {
    id: 'plumbing',
    name: 'Plumbing',
    iconName: 'Droplets',
    tasks: [
      { id: 'plumbing-1', name: "Flush water heater", frequency_days: 365, description: "Drain the geyser/heater to remove sediment buildup." },
      { id: 'plumbing-2', name: "Check for under-sink leaks", frequency_days: 90, description: "Inspect kitchen and bathroom pipes for slow drips." },
      { id: 'plumbing-3', name: "Replace home water filter", frequency_days: 180, description: "Change the main inline water filter cartridge." },
      { id: 'plumbing-4', name: "Descale showerheads", frequency_days: 180, description: "Soak in vinegar to restore water flow." },
      { id: 'plumbing-5', name: "Pour hot water down drains", frequency_days: 30, description: "Prevent clogs by flushing bathroom and kitchen drains." }
    ]
  },
  {
    id: 'outdoor',
    name: 'Outdoor & Garage',
    iconName: 'TreePine',
    tasks: [
      { id: 'outdoor-1', name: "Check lawn mower oil/blades", frequency_days: 180, description: "Top up oil and sharpen blades for the season." },
      { id: 'outdoor-2', name: "Backwash pool filter", frequency_days: 30, description: "Clean the sand/cartridge filter to maintain water flow." },
      { id: 'outdoor-3', name: "Test generator", frequency_days: 30, description: "Run it for 15 minutes to ensure it starts when needed." },
      { id: 'outdoor-4', name: "Apply wood sealant", frequency_days: 180, description: "Oil or seal outdoor wooden furniture/decks." },
      { id: 'outdoor-5', name: "Clean gutters", frequency_days: 180, description: "Remove leaves and debris to prevent water damage." },
      { id: 'outdoor-6', name: "Lubricate garage door tracks", frequency_days: 180, description: "Apply silicone spray to rollers and hinges." }
    ]
  },
  {
    id: 'furniture',
    name: 'Furniture',
    iconName: 'Sofa',
    tasks: [
      { id: 'furn-1', name: "Condition leather couches", frequency_days: 90, description: "Apply leather cream to prevent cracking." },
      { id: 'furn-2', name: "Rotate mattresses", frequency_days: 90, description: "Flip or rotate beds to ensure even wear." },
      { id: 'furn-3', name: "Tighten chair/bed bolts", frequency_days: 180, description: "Go around with an allen key and secure wobbly frames." },
      { id: 'furn-4', name: "Steam clean upholstery", frequency_days: 365, description: "Deep clean fabric couches and dining chairs." },
      { id: 'furn-5', name: "Oil/polish wooden tables", frequency_days: 90, description: "Nourish wood surfaces to prevent drying out." }
    ]
  }
];
